import React from 'react';
import { Modal, Button } from 'antd';
import PropTypes from 'prop-types';
import styles from './Popup.module.css';

function ConfirmActionPopup({
  title,
  visible,
  onCancel,
  onConfirm,
  activeRecord,
  actionType,
  content,
  loading,
  disabled,
  loadingText,
  children,
}) {
  return (
    <Modal
      visible={visible}
      title={title}
      width="600px"
      onCancel={onCancel}
      centered
      onOk={onConfirm}
      className={styles.confirmUserPopup}
      okButtonProps={{
        className: styles.addButton,
      }}
      footer={[
        <Button
          onClick={onConfirm}
          className={styles.addButton}
          disabled={loading || disabled}
        >
          {loading ? (
            <span className="importExportLoader">{loadingText}</span>
          ) : (
            'Confirm'
          )}
        </Button>,
      ]}
    >
      <div className={styles.confirmUserPopupContent}>
        <span className={styles.confirmUserPopupSetence}>
          Are you sure you want to {actionType}{' '}
          <span className={styles.confirmUserName}>
            {activeRecord &&
              (activeRecord.userName ||
                activeRecord.name ||
                activeRecord.workspaceName ||
                activeRecord.modelName ||
                activeRecord.imageName ||
                activeRecord)}
          </span>{' '}
          {content}?<div>{children}</div>
        </span>
      </div>
    </Modal>
  );
}

ConfirmActionPopup.defaultProps = {
  title: '',
  visible: false,
  onCancel: (f) => f,
  onConfirm: (f) => f,
  activeRecord: '',
  actionType: '',
  content: '',
  loading: false,
  disabled: false,
  loadingText: '',
  children: [],
};

ConfirmActionPopup.propTypes = {
  title: PropTypes.string,
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  activeRecord: PropTypes.instanceOf(Object),
  actionType: PropTypes.string,
  content: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  loadingText: PropTypes.string,
  children: PropTypes.node,
};

export default ConfirmActionPopup;
